import React, { useState, useEffect } from 'react';
import { getFirestore, collection, getDocs, deleteDoc, doc } from 'firebase/firestore';
import { getStorage, ref, deleteObject } from 'firebase/storage';
import { useNavigate } from 'react-router-dom';
import useIsAdmin from './useIsAdmin.tsx';
import './Rituel3.css';

interface Rituel {
  titre: string;
  fichier: string;
  id: string;
}

function Rituel3() {
  const navigate = useNavigate();
  const [rituels, setRituels] = useState<Rituel[]>([]);
  const { isAdmin, loading: adminCheckLoading } = useIsAdmin();

  const getStoragePathFromURL = (url: string) => {
    try {
      const regex = /firebasestorage\.googleapis\.com\/v0\/b\/[^/]+\/o\/([^?]+)/;
      const match = url.match(regex);
      if (match && match[1]) {
        const path = decodeURIComponent(match[1]);
        console.log('Chemin extrait:', path);
        return path;
      }
      return null;
    } catch (error) {
      console.error('Erreur lors de l\'extraction du chemin:', error);
      return null;
    }
  };

  useEffect(() => {
    const fetchRituels = async () => {
      try {
        const db = getFirestore();
        const rituelsSnapshot = await getDocs(collection(db, 'Rituels3'));
        const rituelsData = rituelsSnapshot.docs.map(doc => ({
          id: doc.id,
          titre: doc.data().titre || '',
          fichier: doc.data().fichier || ''
        }));
        setRituels(rituelsData);
      } catch (error) {
        console.error('Erreur lors de la récupération des rituels:', error);
      }
    };
    fetchRituels();
  }, []);

  const handleDownload = async (fichier: string) => {
    try {
      window.open(fichier, '_blank');
    } catch (error) {
      console.error('Erreur lors du téléchargement:', error);
    }
  };

  const handleDelete = async (id: string, fichierUrl: string) => {
    if (!isAdmin) {
      alert("Vous n'avez pas les droits d'administrateur nécessaires pour supprimer des fichiers.");
      return;
    }
    
    if (window.confirm('Êtes-vous sûr de vouloir supprimer ce rituel ?')) {
      try {
        // Supprimer le fichier de Storage
        const storage = getStorage();
        const filePath = getStoragePathFromURL(fichierUrl);
        if (filePath) {
          const fileRef = ref(storage, filePath);
          try {
            await deleteObject(fileRef);
            console.log('Fichier supprimé du storage avec succès');
          } catch (storageError) {
            console.error('Erreur lors de la suppression du fichier:', storageError);
          }
        }
        // Supprimer le document de Firestore
        const db = getFirestore();
        const rituelRef = doc(db, 'Rituels3', id);
        await deleteDoc(rituelRef);
        setRituels(rituels.filter(rituel => rituel.id !== id));
       
        console.log('Rituel supprimé avec succès');
      } catch (error) {
        console.error('Erreur lors de la suppression:', error);
      }
    }
  };

  if (adminCheckLoading) {
    return <div>Chargement...</div>;
  }

  return (
    <div className="rituels-container">
      <div className="button-container">
        {isAdmin && (
          <button
            className="ajouter-btn"
            onClick={() => navigate('/mapage/ajouter-rituel-3')}
          >
            Ajouter
          </button>
        )}
      </div>
      <table className="rituels-table">
        <thead>
          <tr>
            <th>Titre</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {rituels.map((rituel) => (
            <tr key={rituel.id}>
              <td>{rituel.titre}</td>
              <td>
                <div className="actions-container">
                  <button
                    onClick={() => handleDownload(rituel.fichier)}
                    className="telecharger-btn"
                  >
                    Télécharger
                  </button>
                  {isAdmin && (
                    <button
                      onClick={() => handleDelete(rituel.id, rituel.fichier)}
                      className="supprimer-btn"
                    >
                      Supprimer
                    </button>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Rituel3